import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'execute-workflow-action',
  version: '1.0.0',
  properties: [
    {
      key: 'notice',
      label: 'Info',
      type: 'notice',
      default: '',
      description: '💡 **Tip:** Only workflows with a **Workflow Trigger** node (found in Triggers category) can be executed as child workflows. The dropdown below will only show workflows that have this trigger node.',
    },
    {
      key: 'workflowId',
      label: 'Workflow',
      type: 'string',
      required: true,
      placeholder: 'Select a workflow',
      description: 'Select a workflow that has a Workflow Trigger node. Only workflows with Workflow Trigger nodes can be executed as child workflows.',
      customComponent: 'WorkflowSelector',
    },
    {
      key: 'waitForCompletion',
      label: 'Wait for Completion',
      type: 'boolean',
      default: true,
      description: 'If enabled, this node will wait for the sub-workflow to complete before continuing. If disabled, the sub-workflow will execute asynchronously.',
    },
    {
      key: 'inputDataMode',
      label: 'Input Data Mode',
      type: 'options',
      default: 'acceptAll',
      options: [
        { 
          name: 'Accept All Data', 
          value: 'acceptAll',
          description: 'Pass all data from this node to the sub-workflow'
        },
        { 
          name: 'Define Using Fields', 
          value: 'defineFields',
          description: 'Map specific fields from this node to the sub-workflow'
        },
        { 
          name: 'Define Using JSON', 
          value: 'defineJson',
          description: 'Define the input data structure using a JSON schema'
        },
      ],
      description: 'How to pass data to the sub-workflow',
    },
    {
      key: 'inputMapping',
      label: 'Input Field Mapping',
      type: 'collection',
      default: {},
      placeholder: 'Add field mapping',
      description: 'Map fields from the current node output to the sub-workflow input. Use expressions like {{ $json.fieldName }} to reference data.',
      displayOptions: {
        show: {
          inputDataMode: ['defineFields'],
        },
      },
      typeOptions: {
        multipleValues: true,
      },
    },
    {
      key: 'inputJson',
      label: 'Input JSON Schema',
      type: 'json',
      default: '{}',
      placeholder: '{ "key": "value" }',
      description: 'Define the input data structure as JSON. You can use expressions to reference data from previous nodes.',
      displayOptions: {
        show: {
          inputDataMode: ['defineJson'],
        },
      },
    },
  ],
};

export default schema;
